"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
exports.defaultPickerIcon = defaultPickerIcon;
var _preact = require("preact");
var _pQueue = _interopRequireDefault(require("p-queue"));
var _generateFileID = require("@uppy/utils/lib/generateFileID");
var _AuthView = _interopRequireDefault(require("./AuthView.js"));
var _Header = _interopRequireDefault(require("./Header.js"));
var _Browser = _interopRequireDefault(require("../Browser.js"));
var _CloseWrapper = _interopRequireDefault(require("../CloseWrapper.js"));
var _View2 = _interopRequireDefault(require("../View.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.13.0"
};
function formatBreadcrumbs(breadcrumbs) {
  return breadcrumbs.slice(1).map(function (directory) {
    return directory.name;
  }).join('/');
}
function prependPath(path, component) {
  if (!path) return component;
  return "".concat(path, "/").concat(component);
}
function defaultPickerIcon() {
  return (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, (0, _preact.h)("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
var defaultOptions = {
  viewType: 'list',
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true,
  loadAllFiles: false,
  virtualList: false
};
var _abortController = /*#__PURE__*/_classPrivateFieldLooseKey("abortController");
var _withAbort = /*#__PURE__*/_classPrivateFieldLooseKey("withAbort");
var _list = /*#__PURE__*/_classPrivateFieldLooseKey("list");
var _listFilesAndFolders = /*#__PURE__*/_classPrivateFieldLooseKey("listFilesAndFolders");
var _recursivelyListAllFiles = /*#__PURE__*/_classPrivateFieldLooseKey("recursivelyListAllFiles");
/**
 * Class to easily generate generic views for Provider plugins
 */
var ProviderView = exports.default = /*#__PURE__*/function (_View) {
  function ProviderView(plugin, opts) {
    var _this2;
    _classCallCheck(this, ProviderView);
    _this2 = _callSuper(this, ProviderView, [plugin, _objectSpread(_objectSpread({}, defaultOptions), opts)]);

    // Logic
    Object.defineProperty(_this2, _recursivelyListAllFiles, {
      value: _recursivelyListAllFiles2
    });
    Object.defineProperty(_this2, _listFilesAndFolders, {
      value: _listFilesAndFolders2
    });
    Object.defineProperty(_this2, _list, {
      value: _list2
    });
    Object.defineProperty(_this2, _withAbort, {
      value: _withAbort2
    });
    Object.defineProperty(_this2, _abortController, {
      writable: true,
      value: void 0
    });
    _this2.filterQuery = _this2.filterQuery.bind(_this2);
    _this2.clearFilter = _this2.clearFilter.bind(_this2);
    _this2.getFolder = _this2.getFolder.bind(_this2);
    _this2.getNextFolder = _this2.getNextFolder.bind(_this2);
    _this2.logout = _this2.logout.bind(_this2);
    _this2.handleAuth = _this2.handleAuth.bind(_this2);
    _this2.handleScroll = _this2.handleScroll.bind(_this2);
    _this2.donePicking = _this2.donePicking.bind(_this2);

    // Visual
    _this2.render = _this2.render.bind(_this2);

    // Set default state for the plugin
    _this2.plugin.setPluginState({
      authenticated: undefined,
      // we don't know yet
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });
    _this2.registerRequestClient();
    return _this2;
  }

  // eslint-disable-next-line class-methods-use-this
  _inherits(ProviderView, _View);
  return _createClass(ProviderView, [{
    key: "tearDown",
    value: function tearDown() {
      // Nothing.
    }
    /**
     * Select a folder based on its id: fetches the folder and then updates state with its contents
     * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
     *
     */
  }, {
    key: "getFolder",
    value: (function () {
      var _getFolder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestPath, name) {
        var _this3 = this;
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.setLoading(true);
              _context2.p = 1;
              _context2.n = 2;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort](/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(signal) {
                  var _this3$plugin$getPlug, breadcrumbs, index, files, folders, _yield$_classPrivateF, newFiles, newFolders;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _this3.lastCheckbox = undefined;
                        _this3$plugin$getPlug = _this3.plugin.getPluginState(), breadcrumbs = _this3$plugin$getPlug.breadcrumbs;
                        index = breadcrumbs.findIndex(function (dir) {
                          return requestPath === dir.requestPath;
                        });
                        if (index !== -1) {
                          // means we navigated back to a known directory (already in the stack), so cut the stack off there
                          breadcrumbs = breadcrumbs.slice(0, index + 1);
                        } else {
                          // we have navigated into a new (unknown) folder, add it to the stack
                          breadcrumbs = [].concat(_toConsumableArray(breadcrumbs), [{
                            requestPath: requestPath,
                            name: name
                          }]);
                        }
                        _this3.nextPagePath = requestPath;
                        files = [];
                        folders = [];
                      case 1:
                        _context.n = 2;
                        return _classPrivateFieldLooseBase(_this3, _listFilesAndFolders)[_listFilesAndFolders]({
                          breadcrumbs: breadcrumbs,
                          signal: signal
                        });
                      case 2:
                        _yield$_classPrivateF = _context.v;
                        newFiles = _yield$_classPrivateF.files;
                        newFolders = _yield$_classPrivateF.folders;
                        files = files.concat(newFiles);
                        folders = folders.concat(newFolders);
                        _this3.setLoading(_this3.plugin.uppy.i18n('loadedXFiles', {
                          numFiles: files.length + folders.length
                        }));
                      case 3:
                        if (_this3.opts.loadAllFiles && _this3.nextPagePath) {
                          _context.n = 1;
                          break;
                        }
                      case 4:
                        _this3.plugin.setPluginState({
                          folders: folders,
                          files: files,
                          breadcrumbs: breadcrumbs,
                          filterInput: ''
                        });
                      case 5:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
              _context2.n = 5;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              if (!((_t == null ? void 0 : _t.name) === 'UserFacingApiError')) {
                _context2.n = 4;
                break;
              }
              this.plugin.uppy.info({
                message: this.plugin.uppy.i18n(_t.message)
              }, 'warning', 5000);
              return _context2.a(2);
            case 4:
              this.handleError(_t);
            case 5:
              _context2.p = 5;
              this.setLoading(false);
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 5, 6]]);
      }));
      function getFolder(_x, _x2) {
        return _getFolder.apply(this, arguments);
      }
      return getFolder;
    }()
    /**
     * Fetches new folder
     */
    )
  }, {
    key: "getNextFolder",
    value: function getNextFolder(folder) {
      this.getFolder(folder.requestPath, folder.name);
      this.lastCheckbox = undefined;
    }

    /**
     * Removes session token on client side.
     */
  }, {
    key: "logout",
    value: (function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this4 = this;
        var _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort](/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(signal) {
                  var res, message, newState;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        _context3.n = 1;
                        return _this4.provider.logout({
                          signal: signal
                        });
                      case 1:
                        res = _context3.v;
                        // res.ok is from the JSON body, not to be confused with Response.ok
                        if (res.ok) {
                          if (!res.revoked) {
                            message = _this4.plugin.uppy.i18n('companionUnauthorizeHint', {
                              provider: _this4.plugin.title,
                              url: res.manual_revoke_url
                            });
                            _this4.plugin.uppy.info(message, 'info', 7000);
                          }
                          newState = {
                            authenticated: false,
                            files: [],
                            folders: [],
                            breadcrumbs: [],
                            filterInput: ''
                          };
                          _this4.plugin.setPluginState(newState);
                        }
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              this.handleError(_t2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }())
  }, {
    key: "filterQuery",
    value: function filterQuery(input) {
      this.plugin.setPluginState({
        filterInput: input
      });
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      this.plugin.setPluginState({
        filterInput: ''
      });
    }
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(authFormData) {
        var _this5 = this;
        var _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort](/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(signal) {
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        _this5.setLoading(true);
                        _context5.n = 1;
                        return _this5.provider.login({
                          authFormData: authFormData,
                          signal: signal
                        });
                      case 1:
                        _this5.plugin.setPluginState({
                          authenticated: true
                        });
                        _this5.preFirstRender();
                      case 2:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 1:
              _context6.n = 4;
              break;
            case 2:
              _context6.p = 2;
              _t3 = _context6.v;
              if (!(_t3.name === 'UserFacingApiError')) {
                _context6.n = 3;
                break;
              }
              this.plugin.uppy.info({
                message: this.plugin.uppy.i18n(_t3.message)
              }, 'warning', 5000);
              return _context6.a(2);
            case 3:
              this.plugin.uppy.log("login failed: ".concat(_t3.message));
            case 4:
              _context6.p = 4;
              this.setLoading(false);
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2, 4, 5]]);
      }));
      function handleAuth(_x5) {
        return _handleAuth.apply(this, arguments);
      }
      return handleAuth;
    }()
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(event) {
        var _this6 = this;
        var _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(this.shouldHandleScroll(event) && this.nextPagePath)) {
                _context8.n = 5;
                break;
              }
              this.isHandlingScroll = true;
              _context8.p = 1;
              _context8.n = 2;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort](/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(signal) {
                  var _this6$plugin$getPlug, files, folders, breadcrumbs, _yield$_classPrivateF2, newFiles, newFolders, combinedFiles, combinedFolders;
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        _this6$plugin$getPlug = _this6.plugin.getPluginState(), files = _this6$plugin$getPlug.files, folders = _this6$plugin$getPlug.folders, breadcrumbs = _this6$plugin$getPlug.breadcrumbs;
                        _context7.n = 1;
                        return _classPrivateFieldLooseBase(_this6, _listFilesAndFolders)[_listFilesAndFolders]({
                          breadcrumbs: breadcrumbs,
                          signal: signal
                        });
                      case 1:
                        _yield$_classPrivateF2 = _context7.v;
                        newFiles = _yield$_classPrivateF2.files;
                        newFolders = _yield$_classPrivateF2.folders;
                        combinedFiles = files.concat(newFiles);
                        combinedFolders = folders.concat(newFolders);
                        _this6.plugin.setPluginState({
                          folders: combinedFolders,
                          files: combinedFiles
                        });
                      case 2:
                        return _context7.a(2);
                    }
                  }, _callee7);
                }));
                return function (_x8) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 2:
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t4 = _context8.v;
              this.handleError(_t4);
            case 4:
              _context8.p = 4;
              this.isHandlingScroll = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function handleScroll(_x7) {
        return _handleScroll.apply(this, arguments);
      }
      return handleScroll;
    }()
  }, {
    key: "donePicking",
    value: function () {
      var _donePicking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _this7 = this;
        var _t6;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              this.setLoading(true);
              _context1.p = 1;
              _context1.n = 2;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort](/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(signal) {
                  var _this7$plugin$getPlug, currentSelection, messages, newFiles, _iterator, _step, _loop, _t5;
                  return _regenerator().w(function (_context0) {
                    while (1) switch (_context0.p = _context0.n) {
                      case 0:
                        _this7$plugin$getPlug = _this7.plugin.getPluginState(), currentSelection = _this7$plugin$getPlug.currentSelection;
                        messages = [];
                        newFiles = [];
                        _iterator = _createForOfIteratorHelper(currentSelection);
                        _context0.p = 1;
                        _loop = /*#__PURE__*/_regenerator().m(function _callee9() {
                          var selectedItem, requestPath, withRelDirPath, isEmpty, numNewFiles, queue, onFiles, message;
                          return _regenerator().w(function (_context9) {
                            while (1) switch (_context9.n) {
                              case 0:
                                selectedItem = _step.value;
                                requestPath = selectedItem.requestPath;
                                withRelDirPath = function withRelDirPath(newItem) {
                                  return _objectSpread(_objectSpread({}, newItem), {}, {
                                    // calculate the file's path relative to the user's selected item's path
                                    // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
                                    relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, '').replace(/^\//, '')
                                  });
                                };
                                if (!selectedItem.isFolder) {
                                  _context9.n = 3;
                                  break;
                                }
                                isEmpty = true;
                                numNewFiles = 0;
                                queue = new _pQueue.default({
                                  concurrency: 6
                                });
                                onFiles = function onFiles(files) {
                                  var _iterator2 = _createForOfIteratorHelper(files),
                                    _step2;
                                  try {
                                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                      var newFile = _step2.value;
                                      var tagFile = _this7.getTagFile(newFile);
                                      var _id = (0, _generateFileID.getSafeFileId)(tagFile, _this7.plugin.uppy.getID());
                                      // If the same folder is added again, we don't want to send
                                      // X amount of duplicate file notifications, we want to say
                                      // the folder was already added. This checks if all files are duplicate,
                                      // if that's the case, we don't add the files.
                                      if (!_this7.plugin.uppy.checkIfFileAlreadyExists(_id)) {
                                        newFiles.push(withRelDirPath(newFile));
                                        numNewFiles++;
                                        _this7.setLoading(_this7.plugin.uppy.i18n('addedNumFiles', {
                                          numFiles: numNewFiles
                                        }));
                                      }
                                      isEmpty = false;
                                    }
                                  } catch (err) {
                                    _iterator2.e(err);
                                  } finally {
                                    _iterator2.f();
                                  }
                                };
                                _context9.n = 1;
                                return _classPrivateFieldLooseBase(_this7, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
                                  requestPath: requestPath,
                                  absDirPath: prependPath(selectedItem.absDirPath, selectedItem.name),
                                  relDirPath: selectedItem.name,
                                  queue: queue,
                                  onFiles: onFiles,
                                  signal: signal
                                });
                              case 1:
                                _context9.n = 2;
                                return queue.onIdle();
                              case 2:
                                if (isEmpty) {
                                  message = _this7.plugin.uppy.i18n('emptyFolderAdded');
                                } else if (numNewFiles === 0) {
                                  message = _this7.plugin.uppy.i18n('folderAlreadyAdded', {
                                    folder: selectedItem.name
                                  });
                                } else {
                                  // TODO we don't really know at this point whether any files were actually added
                                  // (only later after addFiles has been called) so we should probably rewrite this.
                                  // Example: If all files fail to add due to restriction error, it will still say "Added 100 files from folder"
                                  message = _this7.plugin.uppy.i18n('folderAdded', {
                                    smart_count: numNewFiles,
                                    folder: selectedItem.name
                                  });
                                }
                                messages.push(message);
                                _context9.n = 4;
                                break;
                              case 3:
                                newFiles.push(withRelDirPath(selectedItem));
                              case 4:
                                return _context9.a(2);
                            }
                          }, _callee9);
                        });
                        _iterator.s();
                      case 2:
                        if ((_step = _iterator.n()).done) {
                          _context0.n = 4;
                          break;
                        }
                        return _context0.d(_regeneratorValues(_loop()), 3);
                      case 3:
                        _context0.n = 2;
                        break;
                      case 4:
                        _context0.n = 6;
                        break;
                      case 5:
                        _context0.p = 5;
                        _t5 = _context0.v;
                        _iterator.e(_t5);
                      case 6:
                        _context0.p = 6;
                        _iterator.f();
                        return _context0.f(6);
                      case 7:
                        // Note: this.plugin.uppy.addFiles must be only run once we are done fetching all files,
                        // because it will cause the loading screen to disappear,
                        // and that will allow the user to start the upload, so we need to make sure we have
                        // finished all async operations before we add any file
                        // see https://github.com/transloadit/uppy/pull/4384
                        _this7.plugin.uppy.log('Adding files from a remote provider');
                        _this7.plugin.uppy.addFiles(
                        // @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
                        // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
                        // For now it's better to ignore than to have a potential breaking change.
                        newFiles.map(function (file) {
                          return _this7.getTagFile(file, _this7.requestClientId);
                        }));
                        _this7.plugin.setPluginState({
                          filterInput: ''
                        });
                        messages.forEach(function (message) {
                          return _this7.plugin.uppy.info(message);
                        });
                        _this7.clearSelection();
                      case 8:
                        return _context0.a(2);
                    }
                  }, _callee0, null, [[1, 5, 6, 7]]);
                }));
                return function (_x9) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
              _context1.n = 4;
              break;
            case 3:
              _context1.p = 3;
              _t6 = _context1.v;
              this.handleError(_t6);
            case 4:
              _context1.p = 4;
              this.setLoading(false);
              return _context1.f(4);
            case 5:
              return _context1.a(2);
          }
        }, _callee1, this, [[1, 3, 4, 5]]);
      }));
      function donePicking() {
        return _donePicking.apply(this, arguments);
      }
      return donePicking;
    }()
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;
      if (viewOptions === void 0) {
        viewOptions = {};
      }
      var _this$plugin$getPlugi = this.plugin.getPluginState(),
        authenticated = _this$plugin$getPlugi.authenticated,
        didFirstRender = _this$plugin$getPlugi.didFirstRender;
      var i18n = this.plugin.uppy.i18n;
      if (!didFirstRender) {
        this.preFirstRender();
      }
      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);
      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
        files = _this$plugin$getPlugi2.files,
        folders = _this$plugin$getPlugi2.folders,
        filterInput = _this$plugin$getPlugi2.filterInput,
        loading = _this$plugin$getPlugi2.loading,
        currentSelection = _this$plugin$getPlugi2.currentSelection;
      var isChecked = this.isChecked,
        recordShiftKeyPress = this.recordShiftKeyPress,
        filterItems = this.filterItems;
      var hasInput = filterInput !== '';
      var pluginIcon = this.plugin.icon || defaultPickerIcon;
      var headerProps = {
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        getFolder: this.getFolder,
        breadcrumbs: this.plugin.getPluginState().breadcrumbs,
        pluginIcon: pluginIcon,
        title: this.plugin.title,
        logout: this.logout,
        username: this.username,
        i18n: i18n
      };
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: this.toggleCheckbox.bind(this),
        recordShiftKeyPress: recordShiftKeyPress,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        getNextFolder: this.getNextFolder,
        getFolder: this.getFolder,
        loadAllFiles: this.opts.loadAllFiles,
        virtualList: this.opts.virtualList,
        // For SearchFilterInput component
        showSearchFilter: targetViewOptions.showFilter,
        search: this.filterQuery,
        clearSearch: this.clearFilter,
        searchTerm: filterInput,
        searchOnInput: true,
        searchInputLabel: i18n('filter'),
        clearSearchLabel: i18n('resetFilter'),
        noResultsLabel: i18n('noFilesFound'),
        logout: this.logout,
        handleScroll: this.handleScroll,
        done: this.donePicking,
        cancel: this.cancelPicking,
        // eslint-disable-next-line react/jsx-props-no-spreading
        headerComponent: (0, _preact.h)(_Header.default, headerProps),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: pluginIcon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;
          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        },
        isLoading: loading
      };
      if (authenticated === false) {
        return (0, _preact.h)(_CloseWrapper.default, {
          onUnmount: this.clearSelection
        }, (0, _preact.h)(_AuthView.default, {
          pluginName: this.plugin.title,
          pluginIcon: pluginIcon,
          handleAuth: this.handleAuth,
          i18n: this.plugin.uppy.i18nArray,
          renderForm: this.opts.renderAuthForm,
          loading: loading
        }));
      }
      return (0, _preact.h)(_CloseWrapper.default, {
        onUnmount: this.clearSelection
      }, (0, _preact.h)(_Browser.default, browserProps));
    }
  }]);
}(_View2.default);
function _withAbort2(_x0) {
  return _withAbort3.apply(this, arguments);
}
function _withAbort3() {
  _withAbort3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(op) {
    var _this8 = this;
    var _classPrivateFieldLoo, abortController, cancelRequest;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.p = _context10.n) {
        case 0:
          // prevent multiple requests in parallel from causing race conditions
          (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _abortController)[_abortController]) == null || _classPrivateFieldLoo.abort();
          abortController = new AbortController();
          _classPrivateFieldLooseBase(this, _abortController)[_abortController] = abortController;
          cancelRequest = function cancelRequest() {
            abortController.abort();
            _this8.clearSelection();
          };
          _context10.p = 1;
          // @ts-expect-error this should be typed in @uppy/dashboard.
          // Even then I don't think we can make this work without adding dashboard
          // as a dependency to provider-views.
          this.plugin.uppy.on('dashboard:close-panel', cancelRequest);
          this.plugin.uppy.on('cancel-all', cancelRequest);
          _context10.n = 2;
          return op(abortController.signal);
        case 2:
          _context10.p = 2;
          // @ts-expect-error this should be typed in @uppy/dashboard.
          // Even then I don't think we can make this work without adding dashboard
          // as a dependency to provider-views.
          this.plugin.uppy.off('dashboard:close-panel', cancelRequest);
          this.plugin.uppy.off('cancel-all', cancelRequest);
          _classPrivateFieldLooseBase(this, _abortController)[_abortController] = undefined;
          return _context10.f(2);
        case 3:
          return _context10.a(2);
      }
    }, _callee10, this, [[1,, 2, 3]]);
  }));
  return _withAbort3.apply(this, arguments);
}
function _list2(_x1) {
  return _list3.apply(this, arguments);
}
function _list3() {
  _list3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref) {
    var requestPath, absDirPath, signal, _yield$this$provider$, username, nextPagePath, items;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          requestPath = _ref.requestPath, absDirPath = _ref.absDirPath, signal = _ref.signal;
          _context11.n = 1;
          return this.provider.list(requestPath, {
            signal: signal
          });
        case 1:
          _yield$this$provider$ = _context11.v;
          username = _yield$this$provider$.username;
          nextPagePath = _yield$this$provider$.nextPagePath;
          items = _yield$this$provider$.items;
          this.username = username || this.username;
          return _context11.a(2, {
            items: items.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                absDirPath: absDirPath
              });
            }),
            nextPagePath: nextPagePath
          });
      }
    }, _callee11, this);
  }));
  return _list3.apply(this, arguments);
}
function _listFilesAndFolders2(_x10) {
  return _listFilesAndFolders3.apply(this, arguments);
}
function _listFilesAndFolders3() {
  _listFilesAndFolders3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref2) {
    var breadcrumbs, signal, absDirPath, _yield$_classPrivateF3, items, nextPagePath, files, folders;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          breadcrumbs = _ref2.breadcrumbs, signal = _ref2.signal;
          absDirPath = formatBreadcrumbs(breadcrumbs);
          _context12.n = 1;
          return _classPrivateFieldLooseBase(this, _list)[_list]({
            requestPath: this.nextPagePath,
            absDirPath: absDirPath,
            signal: signal
          });
        case 1:
          _yield$_classPrivateF3 = _context12.v;
          items = _yield$_classPrivateF3.items;
          nextPagePath = _yield$_classPrivateF3.nextPagePath;
          this.nextPagePath = nextPagePath;
          files = [];
          folders = [];
          items.forEach(function (item) {
            if (item.isFolder) {
              folders.push(item);
            } else {
              files.push(item);
            }
          });
          return _context12.a(2, {
            files: files,
            folders: folders
          });
      }
    }, _callee12, this);
  }));
  return _listFilesAndFolders3.apply(this, arguments);
}
function _recursivelyListAllFiles2(_x11) {
  return _recursivelyListAllFiles3.apply(this, arguments);
}
function _recursivelyListAllFiles3() {
  _recursivelyListAllFiles3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(_ref3) {
    var _this9 = this;
    var requestPath, absDirPath, relDirPath, queue, onFiles, signal, curPath, res, files, folders, promises;
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          requestPath = _ref3.requestPath, absDirPath = _ref3.absDirPath, relDirPath = _ref3.relDirPath, queue = _ref3.queue, onFiles = _ref3.onFiles, signal = _ref3.signal;
          curPath = requestPath;
        case 1:
          if (!curPath) {
            _context15.n = 4;
            break;
          }
          _context15.n = 2;
          return _classPrivateFieldLooseBase(this, _list)[_list]({
            requestPath: curPath,
            absDirPath: absDirPath,
            signal: signal
          });
        case 2:
          res = _context15.v;
          curPath = res.nextPagePath;
          files = res.items.filter(function (item) {
            return !item.isFolder;
          });
          folders = res.items.filter(function (item) {
            return item.isFolder;
          });
          onFiles(files);

          // recursively queue call to self for each folder
          promises = folders.map(/*#__PURE__*/function () {
            var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(folder) {
              return _regenerator().w(function (_context14) {
                while (1) switch (_context14.n) {
                  case 0:
                    return _context14.a(2, queue.add(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
                      return _regenerator().w(function (_context13) {
                        while (1) switch (_context13.n) {
                          case 0:
                            return _context13.a(2, _classPrivateFieldLooseBase(_this9, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
                              requestPath: folder.requestPath,
                              absDirPath: prependPath(absDirPath, folder.name),
                              relDirPath: prependPath(relDirPath, folder.name),
                              queue: queue,
                              onFiles: onFiles,
                              signal: signal
                            }));
                        }
                      }, _callee13);
                    }))));
                }
              }, _callee14);
            }));
            return function (_x12) {
              return _ref9.apply(this, arguments);
            };
          }());
          _context15.n = 3;
          return Promise.all(promises);
        case 3:
          _context15.n = 1;
          break;
        case 4:
          return _context15.a(2);
      }
    }, _callee15, this);
  }));
  return _recursivelyListAllFiles3.apply(this, arguments);
}
ProviderView.VERSION = packageJson.version;